module.exports = __webpack_public_path__ + "static/img/active4.780fc84a.png";